export const LEGAL_CANCELLATION_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Widerrufsbelehrung</h1>
 Erstattung und Verfahren
</center>

---

## Stornierung und Richtlinien

*Gültig ab dem 19. November 2024*
`;
